/**
 * #705: which built-in workflow does what an approved example says.
 *
 * Mirrors python-backend/app/services/caf_workflows/example_fit.py, which the start gate and the
 * save path use, so the Edit drawer shows the same answer the server acts on. A built-in workflow
 * is keyed by its seed key (`seeds_by_action` in the example links). A workflow an admin built by
 * hand has no key and is not judged; an archived example fits no workflow.
 */
export const FINAL_RESPONSE_SEED = 'final_response';
export const PROVISIONAL_SEED = 'provisional_decision';
const ACTION_SEEDS = new Set([
  'AUTO_ASSIGN_COMPLETE', 'AUTO_ASSIGN_ONLY', 'AUTO_ASSIGN_SEND_LOA', 'AUTO_ASSIGN_MULTI_REP', 'AUTO_ASSIGN_CANCEL_CONFIRM',
]);

/** The built-in workflow key a new approval of this example gets, or null. */
export const matchingSeed = (action: string | null | undefined, stance: string | null | undefined): string | null => {
  if (!action || action === 'AUTO_ARCHIVE') return null;
  if (stance === 'final_response') return FINAL_RESPONSE_SEED;
  return ACTION_SEEDS.has(action) ? action : null;
};

/** True when a workflow with this built-in key (null: built by hand) must not run for the example. */
export const contradicts = (seedKey: string | null, action: string | null | undefined, stance: string | null | undefined): boolean => {
  if (action === 'AUTO_ARCHIVE') return true;
  if (seedKey === null) return false;
  if (seedKey === matchingSeed(action, stance)) return false;
  return !(seedKey === PROVISIONAL_SEED && action === 'AUTO_ASSIGN_COMPLETE' && stance === 'not_final_response');
};
